document.addEventListener("DOMContentLoaded", function () {
  const productAccordionTabs = document.querySelector(
    ".product-accordion-tabs"
  );
  const tabs = productAccordionTabs.querySelectorAll(".tabs-menu__item");
  const contents = productAccordionTabs.querySelectorAll(".tabs-content__item");
  const contentBlock = productAccordionTabs.querySelector(
    ".accordion-tabs__content"
  );

  let touchStartX = 0;
  const SWIPE_THRESHOLD = 50;

  function deactivateAll() {
    tabs.forEach((tab) => tab.classList.remove("active"));
    contents.forEach((c) => c.classList.remove("active"));
  }

  function activateTab(tabElement) {
    const btn = tabElement.querySelector("button");
    const tabId = btn.dataset.tabId;

    deactivateAll();

    tabElement.classList.add("active");
    const content = document.getElementById(tabId);

    if (content) {
      contentBlock.style.height = content.offsetHeight + "px";
      content.classList.add("active");
    }
  }

  tabs.forEach((menuTab) => {
    const btn = menuTab.querySelector("button");
    btn.addEventListener("click", () => {
      // Якщо вкладка вже активна, нічого не робимо
      if (menuTab.classList.contains("active")) return;

      activateTab(menuTab);
    });
  });

  contentBlock.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  // 2. Кінець дотику
  contentBlock.addEventListener("touchend", (e) => {
    const touchEndX = e.changedTouches[0].screenX;
    const currentActiveTab = productAccordionTabs.querySelector(
      ".tabs-menu__item.active"
    );
    const currentIndex = Array.from(tabs).indexOf(currentActiveTab);

    const diffX = touchEndX - touchStartX;

    if (Math.abs(diffX) < SWIPE_THRESHOLD) return;

    if (diffX < 0) {
      const nextIndex = currentIndex + 1;
      if (nextIndex < tabs.length) {
        tabs[nextIndex].querySelector("button").click();
      }
    } else {
      const prevIndex = currentIndex - 1;
      if (prevIndex >= 0) {
        tabs[prevIndex].querySelector("button").click();
      }
    }
  });

  // Відкрити перший таб за замовчуванням
  if (tabs.length) tabs[0].querySelector("button").click();
});
